import { FC } from 'react'
import { generateSrcSet } from 'project/image-proxy-web'
import useWindowSize from 'components/util/useWindowSize'
import Link from 'next/link'

type Props = {}

const TidePromoCard: FC<Props> = () => {
  const size = useWindowSize()
  return (
    <div
      className='card'
      style={{
        backgroundColor: '#273BB6',
      }}
    >
      <div className='d-flex flex-column align-items-center color-white fw-semibold pt-10 px-4 px-lg-8 text-center'>
        <img
          {...generateSrcSet('/images/logos/partners/tide-white.png', 290, 118)}
          alt='Tide Logo'
          className='img-fluid'
          height={118}
          width={290}
          loading='lazy'
        />
        <div className='fs-fluid-40-52 fs-fluid-36-80 lh-105 fw-semibold mb-5 mt-3'>
          Get a free business bank account in minutes with our partner.
        </div>
        <span className='fs-fluid-20-24 lh-114'>
          Having designated business addresses for trading activities can
          enhance a company's credibility and protect the privacy of business
          owners. Open a free Tide business bank account in minutes and get £75
          cashback when you buy our virtual office plan
        </span>
        <Link
          className='w-100 text-decoration-none w-lg-auto my-4 my-lg-0'
          href='/free-business-banking'
        >
          <div className='btn  btn-lg d-flex align-items-center lh-1 justify-content-center btn-outline-white mt-lg-7 mt-2 w-100 w-lg-auto'>
            Find out more
          </div>
        </Link>
      </div>
      <img
        {...generateSrcSet(
          size.isLgOrHigher
            ? '/images/new/robot-head.png'
            : '/images/new/robot-head-small.png',
          size.isLgOrHigher ? 804 : 361,
          size.isLgOrHigher ? 266 : 209,
        )}
        height={size.isLgOrHigher ? 266 : 209}
        width={size.isLgOrHigher ? 804 : 361}
        alt='Robot head'
        className='w-100 h-auto rounded-bottom-img'
        loading='lazy'
      />
    </div>
  )
}

export default TidePromoCard
